import React from 'react'
import { Link } from 'react-router-dom'
import PageLayout from '../../components/PageLayout'
import IntroSection from '../../components/IntroSection'
import { introdata, blogdata } from '../../content_option'
import { useBlogPosts } from '../../hooks/useBlogPosts'
import { formatDate } from '../../utils/dateUtils'

export const BlogCategory = ({ category }) => {
  const { posts, loading, error } = useBlogPosts(category)

  const typewriterStrings = [
    blogdata.description.first,
    blogdata.description.second,
    blogdata.description.third,
  ]

  const renderPosts = () => {
    if (loading) return <p className="loading">Loading posts...</p>
    if (error) return <p className="error">Error loading posts: {error}</p>

    return (
      <ul className="list mb-1x">
        <li>
          <Link className="d-flex flex-column item mt-4 mb-2" to="/blog">
            ← Blog
          </Link>
        </li>
        {posts.map((post) => (
          <li key={post.slug}>
            <Link className="d-flex flex-column item mt-4" to={`/blog/${post.slug}`}>
              <div className="post">{post.title}</div>
              <div className="date">{formatDate(post.date)}</div>
            </Link>
          </li>
        ))}
        {posts.length === 0 && <li><p className="no-posts">No posts yet.</p></li>}
      </ul>
    )
  }

  return (
    <PageLayout title={`Blog — ${category.charAt(0).toUpperCase() + category.slice(1)}`} id="blog" className="blog">
      <IntroSection
        title={introdata.title}
        titleLink="/"
        backgroundImage={blogdata.img_url}
        typewriterStrings={typewriterStrings}
      >
        {renderPosts()}
      </IntroSection>
    </PageLayout>
  )
}
